var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.value),function(item,index){return _c('price-item',{key:index,staticClass:"mb-4",model:{value:(_vm.array[index]),callback:function ($$v) {_vm.$set(_vm.array, index, $$v)},expression:"array[index]"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }